<template>
  <span>
    {{ translatedMatchType }}
  </span>
</template>

<script>
import translateMatchingType from '../../../../../../common/utility/translators/translateMatchingType';

export default {
  name: 'BidsAddBulkPricingTableMatchTypeColumn',
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  computed: {
    translatedMatchType() {
      const {
        row: { matchType },
      } = this;

      return matchType
        ? translateMatchingType(matchType)
        : this.$t('NOT_SPECIFIED');
    },
  },
};
</script>
